import { Controller } from "@hotwired/stimulus"

// Keeps the mapping pickers in step with the columns card above them. A
// mapping's column picker offers only the source columns of its own data type,
// and that type rides along on each option as data. The server renders that
// data once, so retyping a column in the editor left every picker offering the
// old truth until a save.
//
// A column's type select carries the column's position as an action param; on
// change every combobox on the card gets a `combobox:retype` with the new type
// for that position, and re-seats the option itself.
export default class extends Controller {
  retype(event) {
    const position = event.params.position
    if (position === undefined || position === null || position === "") return

    const detail = { value: position, data: { data_type: event.target.value } }
    this.element.querySelectorAll("[data-controller~='combobox']").forEach((combobox) => {
      combobox.dispatchEvent(new CustomEvent("combobox:retype", { detail }))
    })
  }
}
